<template>
    <div class="grid xs-grid-cols-1">
        <div>You may be able to afford a home for {{$filters.formatFriendlyPrice(total)}} instead of renting for {{$filters.formatPrice(monthPay)}}/Mo</div>
        <div class="flex">
            <mvtTextbox>
                <div class="input">
                    <label for="downpayment">Down Payment</label>
                    <mvtInputDecimalNumber id="downpayment" v-model="downpayRate" :suffix="'%'" />
                </div>
            </mvtTextbox>
            <mvtTextbox>
                <div class="input">
                    <label for="homeprice">Home Price</label>
                    <mvtInputNumber id="homeprice" v-model="total" :prefix="'$'"/>
                </div>
            </mvtTextbox>
        </div>
        <div class="f7 text-gray">
            The monthly payment assumes {{$filters.formatPrice(downpayment)}} downpayment, 30 year fixed rate loan with {{interestRate}} Interest rate”
        </div>
        <div class="text-bold">
            <a :href="glb.appUrl + cityPath" class="link f4 ">Homes for sale in {{glb.geo.city}}, {{glb.geo.state}}</a>
        </div>
        <mvtListProperty class="m-t-0" :data="nearbyData" :tracked="false" v-if="nearbyData && nearbyData.length"></mvtListProperty>
    </div>
</template>
<script src="./mvt-nearbyafford.js"></script>
<style lang="scss">
@use "./mvt-nearbyafford.scss" as *;
</style>